// src/merch/logos.js
//
// Approved association logo library (licensed through Jon / the league —
// keep written permission on file for each association).
//
// To add a logo: drop the file (SVG preferred — prints sharp at any size;
// otherwise a PNG at least 2000px wide) in public/merch/logos/ and set
// `file` below. Entries without a file show as "coming soon".
//
// Logos from this library are pre-approved, so they're NOT flagged for
// review the way a customer's own uploaded image is.

export const LOGO_GROUPS = [
  {
    id: "omha-aaa-east",
    label: "OMHA AAA · East",
    logos: [
      { id: "ajax-pickering-raiders", name: "Ajax-Pickering Raiders", file: null },
      { id: "barrie-jr-colts", name: "Barrie Jr Colts", file: null },
      { id: "central-ontario-wolves", name: "Central Ontario Wolves", file: null },
      { id: "greater-kingston-jr-gaels", name: "Greater Kingston Jr Gaels", file: null },
      { id: "markham-waxers", name: "Markham Waxers", file: null },
      { id: "north-central-predators", name: "North Central Predators", file: null },
      { id: "north-shore-whitecaps", name: "North Shore Whitecaps", file: null },
      { id: "peterborough-petes", name: "Peterborough Petes", file: null },
      { id: "quinte-red-devils", name: "Quinte Red Devils", file: null },
      { id: "whitby-wildcats", name: "Whitby Wildcats", file: null },
      { id: "york-simcoe-express", name: "York-Simcoe Express", file: null },
    ],
  },
];

/** Public URL for a logo entry (null if not uploaded yet). */
export const logoUrl = (logo) => (logo.file ? `/merch/logos/${logo.file}` : null);
